<template>
  <div>

    <div class="details-stack">
      <v-row>
        <v-col cols="12">
          <AppTextField :model-value="business_name" label="Business Name" label-icon="mdi-domain"
            placeholder="Acme Services LLC" :error-messages="errors.business_name ? [errors.business_name] : []"
            @update:modelValue="$emit('update:business_name', $event)" />
        </v-col>

        <v-col cols="12">
          <AppTextField
            :model-value="business_email"
            label="Business Email"
            label-icon="mdi-email-outline"
            placeholder="name@company.com"
            :error-messages="errors.business_email ? [errors.business_email] : []"
            @update:modelValue="$emit('update:business_email', $event)"
          />
        </v-col>

        <v-col cols="12">
          <AppPhoneField
            :model-value="business_phone"
            label="Business Phone"
            label-icon="mdi-phone-outline"
            placeholder="(555) 555-5555"
            :error-messages="errors.business_phone ? [errors.business_phone] : []"
            @update:modelValue="$emit('update:business_phone', $event)"
          />
        </v-col>

        <v-col cols="12">
          <AppTextField :model-value="tax_id"
            :label="business_type === 'freelancer' ? 'Social Security Number' : 'EIN / Tax ID'"
            label-icon="mdi-domain" :placeholder="business_type === 'freelancer' ? 'XXX-XX-XXXX' : '12-3456789'"
            :error-messages="errors.tax_id ? [errors.tax_id] : []" @update:modelValue="$emit('update:tax_id', $event)" />
        </v-col>

      </v-row>
    </div>
  </div>
</template>

<script setup lang="ts">
import AppTextField from "@/shared/components/ui/AppTextField.vue";
import AppPhoneField from "@/shared/components/ui/AppPhoneField.vue";

withDefaults(
  defineProps<{
    business_name: string;
    tax_id: string;
    business_type: string;
    business_email?: string;
    business_phone?: string;
    errors: {
      business_name?: string;
      tax_id?: string;
      business_type?: string;
      business_email?: string;
      business_phone?: string;
    };
  }>(),
  {
    business_name: "",
    business_email: "",
    business_phone: "",
    tax_id: "",
    errors: () => ({}),
  },
);

defineEmits([
  "update:business_name",
  "update:tax_id",
  "update:business_email",
  "update:business_phone",
]);
</script>

<style scoped>
.section-title {
  text-transform: capitalize;
}

.section-subtitle {
  margin: 0 0 14px;
  color: #73829a;
  font-size: 14px;
}

.details-stack {
  display: flex;
  flex-direction: column;
  gap: 14px;
}
</style>
